import { useAddressValidation } from '@montugroup/circuit-shared';
import useUserProfileData from '@montugroup/circuit-shared/hooks/user/useGetUserProfile';
import { useMemo } from 'react';
import { useFeatureFlag } from '../useFeatureFlag';
import useUpdateUserProfile from '../user/useUpdateUserProfile';

// NOTE: This hook will eventually own checkout flow UI eg: which page (step) of the checkout the user is in and checkout step progress validation
export function useCheckout() {
  const shouldBlockExternalTerritoryPostcodes = useFeatureFlag('enable_blocking_external_territories');
  const { data: userProfileData, isFetching: isFetchingUserProfile } = useUserProfileData();
  const { isPending: isUpdatingUserProfile } = useUpdateUserProfile();
  const { validatePostcodeNotBlockedFromDelivery } = useAddressValidation();

  const addressValidity = useMemo(() => {
    if (!shouldBlockExternalTerritoryPostcodes) {
      return {
        isValid: true,
      };
    }

    if (!userProfileData) {
      return {
        isValid: true,
      };
    }

    return validatePostcodeNotBlockedFromDelivery(userProfileData.user.zip_code);
  }, [shouldBlockExternalTerritoryPostcodes, userProfileData, validatePostcodeNotBlockedFromDelivery]);

  return {
    addressValidity,
    isAddressValidityLoading: isFetchingUserProfile || isUpdatingUserProfile,
  };
}
